import './Login.css'
import { logoLightSVG } from '../assets/index'
import { FaQuestionCircle } from "react-icons/fa";
import { useState } from 'react'
import { getUserInfo } from '../data/userData'
import { clearPersistedGridState } from '../helpers/useSessionState'
import { clearCachedPreferences } from '../helpers/userPreferences'
import { Loader } from '@progress/kendo-react-indicators';

interface Login {
    onLogin: (email?: string, password?: string) => boolean;
}

const apiURL = process.env.REACT_APP_API_URL;

const Login = ({ onLogin }: Login) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginClass, setLoginClass] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: any) => {
        setLoading(true);
        e.preventDefault();

        try {
            console.log('Logging in...');
            const response = await fetch(`https://${apiURL}/Token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            if (!response.ok) {
                setLoginClass('1px solid #FE5B2D')

                // The API explains why (unknown email, locked account, bad password);
                // fall back to a generic message if it sends nothing useful.
                const serverMessage = (await response.text()).trim();
                setErrorMessage(
                    serverMessage && !serverMessage.startsWith('{')
                        ? serverMessage
                        : 'Wrong details entered'
                );
                throw new Error('Login failed.');
            }

            const data = await response.json();
            const token = data.token;

            setLoginClass('1px solid #C6E923')
            setErrorMessage('');

            // Don't inherit the previous user's saved grid filters or preferences
            // on a shared machine
            clearPersistedGridState();
            clearCachedPreferences();

            await localStorage.setItem('authToken', token);
            await localStorage.setItem('userEmail', email); // Store email for token refresh
            await getUserInfo(email);

            onLogin();

        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login__wrapper">
            <div className="login__container">
                <form className='login__form'>
                    <div className='login__form__image'>
                        <img alt="Bamfords logo" src={logoLightSVG} width={150} />
                    </div>
                    <div className='login__form__items'>
                        <p style={{ fontSize: "10pt", fontFamily: "Inter, sans-serif" }}>{errorMessage}</p>
                        <input
                            placeholder='email'
                            type='email'
                            name='email'
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            required
                            style={{ border: loginClass }}
                            className='login__input'>
                        </input>

                        <input
                            placeholder='password'
                            type='password'
                            name='password'
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            required
                            style={{ border: loginClass }}
                            className='login__input'>
                        </input>

                        {
                            loading ? (
                                <button onClick={handleSubmit} type="submit" className='login__button'>
                                    <Loader size="small" type="infinite-spinner" style={{color: "rgb(58, 15, 15)"}} />
                                </button>
                            ) : (
                                <button onClick={handleSubmit} type="submit" className='login__button'>login</button>
                            )
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Login